import type { OrganizationSettings } from '@travel-planner/shared/schemas';

export type ContactFieldSection = 'commercial' | 'travelPreferences' | 'notes';

export type ToggleableContactField = {
  /** Must match the Contact property name (contactSchema in shared). */
  key: string;
  label: string;
  section: ContactFieldSection;
};

export const TOGGLEABLE_CONTACT_FIELDS: readonly ToggleableContactField[] = [
  { key: 'consortium', label: 'Consortium', section: 'commercial' },
  { key: 'lifecycleStage', label: 'Lifecycle', section: 'commercial' },
  {
    key: 'preferredHotelType',
    label: 'Preferred hotel type',
    section: 'travelPreferences',
  },
  {
    key: 'regionsOfInterest',
    label: 'Regions of interest',
    section: 'travelPreferences',
  },
  {
    key: 'estimatedBudget',
    label: 'Estimated budget',
    section: 'travelPreferences',
  },
  { key: 'numberOfDays', label: 'Days', section: 'travelPreferences' },
  {
    key: 'numberOfPassengers',
    label: 'Passengers',
    section: 'travelPreferences',
  },
  { key: 'arrivalDate', label: 'Arrival', section: 'travelPreferences' },
  { key: 'departureDate', label: 'Departure', section: 'travelPreferences' },
  {
    key: 'foodRestrictions',
    label: 'Food restrictions',
    section: 'travelPreferences',
  },
  {
    key: 'specialOccasion',
    label: 'Special occasion',
    section: 'travelPreferences',
  },
  {
    key: 'travellerInterests',
    label: 'Traveller interests',
    section: 'travelPreferences',
  },
  { key: 'tripBriefing', label: 'Trip briefing', section: 'notes' },
] as const;

export const CONTACT_FIELD_SECTION_LABELS: Record<ContactFieldSection, string> =
  {
    commercial: 'Commercial',
    travelPreferences: 'Travel preferences',
    notes: 'Notes',
  };

/**
 * Default-hidden: a field is visible ONLY when the org explicitly stored `true`.
 * Missing key / missing settings / `false` => hidden. New (migration-added)
 * contact fields stay off until an admin opts in from org settings.
 */
export const isContactFieldVisible = (
  key: string,
  settings: OrganizationSettings | null | undefined
): boolean => settings?.contactFieldVisibility?.[key] === true;
